module.exports = __webpack_public_path__ + "static/media/bl.5b00ddbe.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/bl.svg
// module id = 67
// module chunks = 0